import React from 'react';
import { A11Y_ROLES } from '@/utils/a11y-attrs';
import { RoadTestScheme } from '@/fetch/bussiness/roadtest/types';

export interface SchemeInfoProps {
  scheme: RoadTestScheme;
}

/**
 * 途径点位和测试项的渲染组件
 *
 * @param {*} { scheme }
 * @return {*}
 */
const SchemeInfo: React.FC<SchemeInfoProps> = ({ scheme }) => {
  return (
    <div
      className="scheme-info"
      data-testid="scheme-info"
      {...A11Y_ROLES.region(`方案详情 - ${scheme.schemeName}`)}
    >
      {/* 测试项 - flex: 1 (50%) */}
      <div className="scheme-section item-section">
        <div className="scheme-section-title">测试项</div>
        <div className="scheme-item-tags">
          {(scheme.itemList || []).map((item) => (
            <span key={item.itemNo} className="scheme-item-tag">
              {item.itemName}
            </span>
          ))}
          {(!scheme.itemList || scheme.itemList.length === 0) && (
            <span className="scheme-empty-text">暂无测试项</span>
          )}
        </div>
      </div>

      {/* 途径点位 - flex: 1 (50%) */}
      <div className="scheme-section stop-section">
        <div className="scheme-section-title">途径点位</div>
        <div className="scheme-stop-timeline">
          {(scheme.stopList || []).map((stop, index) => (
            <div
              key={stop.stopId}
              className="scheme-stop-timeline-item"
              data-testid={`scheme-stop-${stop.stopId}`}
            >
              <div className="timeline-dot" />
              {index < (scheme.stopList || []).length - 1 && (
                <div className="timeline-line" />
              )}
              <span className="timeline-text">{stop.stopName}</span>
            </div>
          ))}
          {(!scheme.stopList || scheme.stopList.length === 0) && (
            <span className="scheme-empty-text">暂无途径点位</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(SchemeInfo);
